import axios from "axios";

const post = async ({ path, body }) => {
  try {
    const port = process.env.PORT || 3001;
    const BACKEND_URL =process.env.NODE_ENV === "production" ? "https://reparty-ribi.onrender.com" : process.env.BACKEND_URL || `http://localhost:${port}`;

       

    const response = await axios.post(`${BACKEND_URL}/${path}`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error in POST request:",
      error.response?.data || error.message
    );
    throw error; // Allow caller to handle errors
  }
};

export const sendMailFromKlaviyo = async (payload) => {
  return post({ path: "subscribe", body: payload });
};
